import React from "react";
import ReactDOM from "react-dom/client";
import "./index.scss";
import App from "./App";
import "./GlobalConfig.css";
import setupLocatorUI from "@locator/runtime";
import {FloatButton} from "antd";
import {Provider} from "react-redux";
import store from "./Redux/Store";
import {ReactComponent as UpArrow} from "./assets/icons/scrollToTop.svg";

if (process.env.NODE_ENV === "development") {
  setupLocatorUI();
}

const root = ReactDOM.createRoot(document.getElementById("root"));
root.render(
  <Provider store={store}>
    <App />
    <FloatButton.BackTop
      className="ant-back-top-inner "
      visibilityHeight={700}
      icon={<UpArrow />}
    ></FloatButton.BackTop>
  </Provider>,
);
